/**
 * tile-positions.ts — re-exports locked tile positions with TS types.
 * Source of truth: data/board/tile-positions.json (frozen 2026-05-11).
 * DO NOT recompute or "improve" these values.
 */

import rawPositions from "../../../../../data/board/tile-positions.json";

export interface TilePosition {
  index: number;
  type: string;
  x: number; // normalized [0..1] of CANVAS_W
  y: number; // normalized [0..1] of CANVAS_H
}

export const TILE_POSITIONS: readonly TilePosition[] = rawPositions.tiles as TilePosition[];
export const TILE_COUNT = rawPositions.tile_count; // 33
